import { ClassDetailComponent } from './../class-detail/class-detail.component';
import { Component, OnInit, Input } from '@angular/core';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { Student } from '../data/student';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { OrganizationService } from '../organization.service';
import { Class } from '../data/class';
import { Observable, of } from 'rxjs';
import { tap, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ParentAccount } from '../data/parent-account';
import { Course } from '../data/course';

@Component({
  selector: 'app-add-student-modal',
  templateUrl: './add-student-modal.component.html',
  styleUrls: ['./add-student-modal.component.scss']
})
export class AddStudentModalComponent extends ModalBaseComponent<Student> implements OnInit {

  constructor(protected modalService: NgbModal, protected dataService: DataService, private organizationService: OrganizationService) {
    super(modalService, dataService);
  }

  @Input() class: Class;
  @Input() studentsInClass: Student[];
  @Input() parentId: number;
  @Input() selectableCourses: Course[];

  studentSearchResults: Student[];
  processedResutls: string[];
  studentName: string;
  moveStudent: boolean = false;
  courseCode: string = "PlacementTest";
  gradeLevel: string;

  get studentGradeLevelOptions() {
    return Student.gradeLevelOptions;
  }

  getGradeLevelString(gradeLevel: string) {
    return Student.getGradeLevelString(gradeLevel);
  }

  ngOnInit() { }

  initializeNewData(): void {
    this.studentName = "";
    this.data = new Student();
  }

  enteredStudentExists() {
    var studentExists = this.studentSearchResults != null && this.studentSearchResults.find(a => a.ID === this.data.ID && a.Name === this.data.Name) != null;
    return studentExists;
  }

  searchExistingStudents = (text$: Observable<string>) =>
    text$.pipe(
      tap(() => this.data = new Student()),
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term => {
        if (term.length > 2) {
          return this.dataService.findStudentsByAccount(term).pipe(
            map(students => students.filter(s => !this.studentsInClass.find(other => other.ID === s.ID))),
            tap(students => this.studentSearchResults = students)
          );
        }
        else {
          return of([]);
        }
      })
    )

  resultFormatter = (result: Student) => result.Name + ", ID: " + result.ID;
  inputFormatter = (selection: Student) => selection.Name;

  existingStudentSelected(selectedStudent: Student) {
    this.data = selectedStudent;
    this.studentName = this.data.Name;
  }

  isInputValid(): boolean {
    return this.enteredStudentExists() || this.studentName && this.studentName.length >= 3;
  }

  moveStudentToNewClass() {
    this.moveStudent = true;
    this.modalSubmitted();
  }

  saveEdit(): void {
    throw new Error("Method not implemented.");
  }

  saveNew(): void {
    this.isWaiting = true;
    if (this.enteredStudentExists()) {
      this.dataService.addStudentToClass(this.data.ID, this.class.ID, false, this.moveStudent).subscribe(a => this.saveComplete(a));
    } else {
      if (this.class) {
        this.dataService.createStudent(this.studentName, this.data.ExternalID, this.courseCode, this.class.ID, null, this.gradeLevel).subscribe(a => this.saveComplete(a));
      } else if (this.parentId) {
        this.dataService.createStudent(this.studentName, this.data.ExternalID, this.courseCode, null, this.parentId, this.gradeLevel).subscribe(a => this.saveComplete(a));
      }
    }
  }
}
